<script setup>
import {ref, onBeforeMount, nextTick} from "vue";

import SubpageHeader from "@/components/organisms/header/SubpageHeader.vue";
import MainSection from "@/components/templates/mainSection.vue";
import MainFooter from "@/components/organisms/footer/MainFooter.vue";
import BodyContain from "@/components/molcules/layout/bodyContain.vue";
import SubjectBox from "@/components/organisms/curriculum/subjectBox.vue";
import { route } from "@/router/route";
import { router } from "@/router";
import MenuApi from "@/api/menu";
import { getRouteByHomeLink, findMenuSection } from "@/util/menuUtil";
import SubjectApi from "@/api/subject";
import { useToast } from "vue-toastification";
import { displayHooks } from "@/hooks/useDisplay";
import CommonApi from "@/api/common";
const toast = useToast();

let useDisplayRef = ref(displayHooks);
let mainSectionMenu = ref([]);
let menuValue = ref("");
let selectBoxYearList = ref([]);
let selectYear = ref(new Date().getFullYear());

let selectSmstCdList = ref([{id: '', text : '전체'}]);
let selectSmstCd = ref([]);

let courseList = ref([]); // 개설 교과목 목록
let majrTyList = ref([]); // 전공 분류 목록
let menuMajrTyList = ref([]);

const isVisible = ref(false);

onBeforeMount(() => {

  getMenu();
  getSmstCdList();
  getKCultureRegCurrSubList();
});

//년도 선택
function yearList(startYear, addAll){
  let date = new Date();
  let com_year = date.getFullYear();
  let yearList = [];
  if(addAll)
    yearList.push({id:'', year : "선택안함"});

    for(let i=com_year; i >= 2023; i--) {
      yearList.push({id:''+i, year:i});
    }
    return yearList;
}

selectBoxYearList.value = yearList('2023', false);

function selectYearOption(year){
  selectYear.value = year.year;
}

//학기 공통코드
async function getSmstCdList(){
  let data = {
    upprCodeId: '0000050000'
  };

  let response = await CommonApi.postSmstCdListForExternal(data);
  selectSmstCdList.value.push(...response.data.result.list);
}

//학기 선택
function selectedSmstCd(id) {
  if(id != null && id != '' && id != undefined){
    if(selectSmstCd.value.includes(id)){
      selectSmstCd.value = selectSmstCd.value.filter(i => i != id);
    } else {
      selectSmstCd.value.push(id);
    }

    let findsmstCd = selectSmstCdList.value.find(findsmstCd => findsmstCd.id == null || findsmstCd.id == '' || findsmstCd == undefined);
    if(findsmstCd){
      findsmstCd.checked = false;
    } 
    } else {
      selectSmstCd = ref([]);

      selectSmstCdList.value.forEach(findsmstCd => {
        if(findsmstCd.id != null && findsmstCd.id != '' && findsmstCd.id != undefined){
          findsmstCd.checked = false;
        }
      })
    }
  }

//초기화
function filterInit() {
  selectYear.value = new Date().getFullYear();
  selectSmstCd = ref([]);
  selectSmstCdList.value.forEach(findsmstCd => {
    findsmstCd.checked = false;
  })
}
function filterFunc() {

  getKCultureRegCurrSubList();
}
// 개설 과목 가져오기..
async function getKCultureRegCurrSubList() {
  menuMajrTyList = ref([{majrCd: 'all', majrNm: '전체'}]);

  let data = {
      year: selectYear.value,
      smstCd: selectSmstCd.value,
  };

  let response = await SubjectApi.getKCultureRegCurrSubList(data);
    courseList.value = response.data.result.list;
    majrTyList.value = response.data.result.majrTyList;
    menuMajrTyList.value.push(...response.data.result.majrTyList)

    courseList.value.forEach(obj => {
      if(obj.majrTyList != undefined)
        obj.majrTyList = JSON.parse(obj.majrTyList);
    })

    majrTyList.value.forEach(obj => {
        obj.visibleCnt = 9;
    })
}

//더보기 버튼 클릭 시..
function courseMoreBtn(majrCd) {
  let majrObj = majrTyList.value.find(item => item.majrCd == majrCd);
  majrObj.visibleCnt += 9;
}

// 자세히 보기
function goToDetailPage(item) {
  router.push({
    name: 'curriculum02Detail',
    query: {
      lctrShdlCd: item.lctrShdlCd,
      operAcplCd: item.operAcplCd
    },
  });
}

const getMenu = async () => {
  try {
    const arr = [];

    const data = {
      exposureFlag: true,
    };

    const response = await MenuApi.get(data);
    if (response.data.data) {
      const sectionMenu = findMenuSection(response.data.data.content, "curriculum");
      const subMenu = sectionMenu?.subMenus || [];
      subMenu.map((item, index) => {
        if (item.contentsFlag) {
          arr.push({
            value: item.title,
            label: item.title,
            routeName: route.board + `/${item.boardId}`,
          });
        } else {
          arr.push({
            value: item.title,
            label: item.title,
            routeName: getRouteByHomeLink(item.homeLink) || route[`curriculum${index + 1}`],
          });
        }

        if (item.homeLink === "/curriculum02") {
          menuValue.value = item.title;
        }
        return;
      });

      mainSectionMenu.value = arr;
    }
  } catch (e) {
    toast("서버에 문제가 있습니다. 잠시후 다시 시도하세요.", {
      toastClassName: "toast-wrapper",
      position: "top-center",
      timeout: 2000,
      hideProgressBar: true,
      closeButton: false,
      icon: false,
    });
  }
};

function toggleModal() {
  isVisible.value = !isVisible.value;
  if (isVisible.value) {
    nextTick(() => {
      centerPopup();
    });
  }
}
function centerPopup() {
  let popupInner = document.querySelector("#subject .inner");
  let popupHeight = popupInner.clientHeight;
  let windowHeight = window.innerHeight;
  let marginForCenter = (windowHeight - popupHeight) / 2;
  if (windowHeight <= popupHeight) {
    marginForCenter = 100;
  }
  popupInner.style.marginTop = marginForCenter + "px";
}

const courseFilter = (item) => {
  return courseList.value
        .filter((args) => typeof args.majrTyList !== 'undefined' && args.majrTyList
        .some((object) => object.majr_cd === item.majrCd));
}

</script>

<template>
  <SubpageHeader />
  <MainSection
      bgUrl="curriculum"
      :options="mainSectionMenu"
      :menuValue="menuValue"
      mainHeader="교육과정"
      subHeader01="Home"
      subHeader02="교육과정"
  />

  <BodyContain style="padding-bottom: 120px">
    <div class="art-inner">
      <div class="art-top">
        <PretendardText class="intro-title">개설 과목</PretendardText>
      </div>
      <div class="select-wrap">
        <a class="btn subject" @click="toggleModal">학기 별 개설과목 보기</a>
      </div>
    </div>
    <template v-for="(item, idx) in majrTyList" :key="idx">
        <PretendardText class="intro-title" :style="`margin-top: ${useDisplayRef.isMobile && idx > 0 ? '60px' : !useDisplayRef.isMobile && idx > 0 ? '80px' : ''}`">{{ item.majrNm }}</PretendardText>
          <div class="subject-wrapper">
            <template v-for="(obj, i) in courseFilter(item).slice(0, item.visibleCnt)" :key="i">
              <SubjectBox
                  :title="obj.sbcKrnm"
                  :level="obj.grdNm"
                  :credit="obj.gdptNm"
                  :teacher="obj.pfList"
                  @click="goToDetailPage(obj)"/>
            </template>
          <div class="more-wrapper">
            <button class="more" v-if="courseFilter(item).length > item.visibleCnt" @click="courseMoreBtn(item.majrCd)">더보기</button>
          </div>
        </div>
    </template>
    <!-- 팝업 추가 -->
    <div class="popup" id="subject" v-if="isVisible">
      <div class="inner" style="display: block">
        <span class="line"></span>
        <div class="semester-pop">
          <p class="tit">학기 선택
            <img class="btn close"
                 alt="" @click="toggleModal"
                 src="../../../assets/ico/btn/ico-pop-close.png"
                 style="float: right"/>
          </p>
          
          <!-- 학기별 개설과목 년도 선택-->
          <div class="select">
            <select v-model="selectYear">
              <option v-for="year in selectBoxYearList" v-bind:key="year.id" :value="year.year" @click="selectYearOption(year)">
                {{ `${year.year}년도` }}
              </option>
            </select>
          </div>

          <div class="chk-wrap" style="text-align: left">
              <label v-for="(obj, idx) in selectSmstCdList" :key="idx">
                <input
                  type="checkbox"
                  :value="obj.id"
                  v-model="obj.checked"
                  @change="selectedSmstCd(obj.id)"
                />
                <i></i>
                <s></s>
                <span>{{ obj.text }}</span>
              </label>
            </div>

          <div class="submit-wrap">
            <a class="btn reset" @click="filterInit()"><i></i>
              초기화</a>
            <a class="btn submit" @click="filterFunc()">적용하기</a>
          </div>
        </div>
      </div>
    </div>
  </BodyContain>
  <MainFooter />
</template>

<style lang="scss" scoped>
.intro-title {
  width: 100%;
  color: $black;
  font-size: 32px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.6px;
  padding-bottom: 20px;
  border-bottom: 1px solid $line;
  margin-bottom: 50px;

  @include mobile {
    font-size: 20px;
    margin-bottom: 30px;
  }
}
.subject-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  @include mobile {
    flex-direction: column;
    gap: 0px;
  }
}

.art-inner {
  padding: 0rem;
  max-width: 100%;
  position: relative;

}
.select{
  margin-bottom: 0.8666666rem;
}
.select-wrap {
  float: right;
  margin-bottom: 0.83333333rem;
}

.select-wrap .subject {
  font-size: 1rem;
  line-height: 0.77777778rem;
  color: #282828;
  height: 3.8rem;
  width: 13rem;
  font-weight: 700;
  font-size: 1.2rem;
  text-align: center;
  position: relative;
  padding: 0.36111111rem 1.33333333rem 0.261111rem 0.7555556rem;
  background-color: #ffffff;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 0.27777778rem;
  overflow: hidden;
  margin-bottom: 0.83333333rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  box-shadow: 0px 2px 10px 0px rgba(40, 40, 40, 0.15);
}

.select-wrap .subject:after {
  background-image: url('../../../../public/images/mo/curr/ico-gt.png');
  background-repeat: no-repeat;
  background-size: contain;
  content: "";
  display: block;
  width: 1.2rem;
  height: 1.2rem;
  position: absolute;
  left: auto;
  bottom: auto;
  margin-left: 10.5rem;
}
.more-wrapper{
  text-align: center;
  width: 100%;
}
.more {
  border-radius: 10px;
  display: inline-block;
  width: 10rem;
  border: 1px solid #d9d9d9;
  font-weight: 700;
  margin-top: 0.4rem;
  height: 5rem;
  background-color: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(40, 40, 40, 0.15);
  font-size: 1.2rem;
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: -50;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.inner {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 35rem;
  height: 28rem;
  max-width: 90%;
  position: relative;

}

.semester-pop .tit {
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 0.8rem;
  font-weight: 800;
  color: #044a85;
  margin-bottom: 2rem;
  text-align: center;
  margin-top: 1.2rem;
}

.popup .inner .line {
  background: linear-gradient(90deg, #044a85 1.64%, #021f85 100%);
  display: block;
  height: 5px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}


.select select {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 3.5rem;
  font-size: 1.3rem;
}

.chk-wrap {
  margin-bottom: 2rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid #d9d9d9;
}

.chk-wrap label {
  display: inline-block;
  vertical-align: middle;
  padding-top: 0.81666667rem;
  padding-right: 0.55555556rem;
  padding-bottom: 0.41666667rem;
  padding-left: 0.75555556rem;
  box-sizing: border-box;
  text-align: left;
  width: 10.896rem;
  height: 2.9rem;
  position: relative;
  margin-left: -1px;
  margin-bottom: -1px;
  font-weight: 480;
}

.chk-wrap label s{
  width: 100%;
  height: 100%;
  border: 1px solid #d9d9d9;
  position: absolute;
  left: 0rem;
  top: 0rem;
  right: auto;
  bottom: auto;
  box-sizing: border-box;

}
.chk-wrap input[type="checkbox"] {
  margin-right: 10px;
}

.submit-wrap {
  padding-top: 0.8333333rem;
  display: flex;
  justify-content: space-between;
}

.btn {
  font-weight: 700;
  display: inline-block;
  padding: 16px 20px;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  color: #4d5054;
  border: 1px solid #d9d9d9;
  width: 8rem;
  height: 3.5rem;
}
.btn.reset {
  border-radius: 0.5777778rem;
}
.btn.reset i{
  background-image: url('../../../../public/images/mo/curr/ico-reset.png');
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  width: 1.3rem;
  height: 1.3rem;
  vertical-align: middle;
  margin-top: 3px;
}
.btn.reset:hover{
  background: #D9D9D9;
}
//.btn.close {
//  width: 25px;
//  float: right;
//  height: 25px;
//  padding: 0px;
//  background: darkgray;
//  cursor: pointer;
//}
.btn.close {
  width: 35px;
  height: 35px;
  padding: 0;
  background-color: #021f85;
  cursor: pointer;
  position: absolute;
  top: 0px;
  border-radius: 0 0.13888889rem 0.13888889rem 0;
  border-color: #021f85;
  right: -35px;
}
.btn i {
  margin-right: 5px;
}
.btn.submit{
  font-weight: 700;
  display: inline-block;
  padding: 16px 20px;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  color: #044a85;
  border: 1px solid #044a85;
  width: 8rem;
  height: 3.5rem;
  border-radius: 0.5777778rem;
}
.btn.submit:hover {
  background-color: #f2fcff;
}
</style>
